/**
 * AuditTablePrimitives.tsx
 * Shared table cell and KPI card components used across audit sub-views.
 */
import React from 'react';

export function Th({ children, right }: { children: React.ReactNode; right?: boolean }) {
  return (
    <th style={{ padding: '5px 10px', textAlign: right ? 'right' : 'left',
      fontSize: 9, fontWeight: 700, letterSpacing: '.6px', color: 'var(--t3)',
      fontFamily: 'var(--mono)', textTransform: 'uppercase', borderBottom: '1px solid var(--border)' }}>
      {children}
    </th>
  );
}

export function Td({ children, right, color }: { children: React.ReactNode; right?: boolean; color?: string }) {
  return (
    <td style={{ padding: '4px 10px', textAlign: right ? 'right' : 'left',
      fontSize: 11, color: color ?? 'var(--t1)', fontFamily: 'var(--mono)',
      borderBottom: '1px solid var(--border)11' }}>
      {children}
    </td>
  );
}

export function KPI({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)',
      borderRadius: 6, padding: '10px 14px', minWidth: 90 }}>
      <div style={{ fontSize: 9, color: 'var(--t3)', fontFamily: 'var(--mono)',
        letterSpacing: '.6px', textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 18, fontWeight: 700, color: color ?? 'var(--t1)',
        fontFamily: 'var(--mono)' }}>{value}</div>
    </div>
  );
}

export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  const [open, setOpen] = React.useState(true);
  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 6, overflow: 'hidden' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '8px 12px', background: 'var(--surface2)', cursor: 'pointer',
          fontSize: 11, fontWeight: 700, color: 'var(--t2)' }}>
        <span>{title}</span>
        <span style={{ fontSize: 10, color: 'var(--t3)' }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && <div style={{ padding: '10px 12px' }}>{children}</div>}
    </div>
  );
}

export const tbStyle = { width: '100%', borderCollapse: 'collapse' as const };
